// Import dependencies
import { unsafeCSS, css, html, render, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import definitions
import { getLoop } from '@automator/builder/definitions/items';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop-iterable-expression-token' )
export class AutomatorBuilderItemLoopIterableExpressionToken extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The unique ID of the parent
	@property( { type: Number, attribute: 'parent-id' } ) accessor parentID;

	// The unique ID of this loop block
	@property( { type: Number, attribute: 'loop-id' } ) accessor id;

	// Information about what has to be iterated (e.g. users, posts, tokens)
	@property( { type: Object, attribute: false } ) accessor iterableExpression;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="iterable-expression">
				<uap-builder-item-sentence
					item-id=${ this.loopID }
					.sentence=${ this.directoryLoopData.sentence }
					.fields=${ JSON.parse( this.iterableExpression.fields ) }
					non-interactive-pills
				></uap-builder-item-sentence>
				
				<uo-button
					@click=${ this.handleOpenEditDialog }
					color="transparent"
					size="small"
				>
					<uo-icon id="pencil"></uo-icon>
				</uo-button>
			</div>
		`;
	}

	/**
	 * Handles the click event on the pencil icon
	 */
	handleOpenEditDialog() {
		this.createEditFieldsDialog();
	}

	/**
	 * Creates the dialog that lets the user edit the fields of the loop iterable expression
	 */
	createEditFieldsDialog() {
		// Create the node that we'll use to render the dialog
		// This node will be added as a direct child of the body node.
		// We can't add it inside the component created on this class because of z-index issues
		const $wrapper = document.createElement( 'div' );
		document.body.append( $wrapper );

		// Parse fields
		let fields = this.iterableExpression.fields;
		try {
			fields = JSON.parse( fields );
		} catch ( e ) {}

		render(
			html`
				<uap-builder-item-loop-edit-dialog
					parent-id=${ this.parentID }
					loop-id=${ this.id }
					type=${ this.iterableExpression.type }
					.fields=${ fields }
				></uap-builder-item-loop-edit-dialog>
			`,
			$wrapper
		);
	}

	/**
	 * Returns the global/directory data of this loop
	 *
	 * @return {Object} The directory data of this loop. This contains, for example, the fields attributes
	 */
	get directoryLoopData() {
		return getLoop( this.iterableExpression.type );
	}
}